const checkKiwiSizingChart = () => { 
  var kiwiSizingChart = document.querySelector('.ks-chart-container .ks-chart-modal-link');
  var teeOptionTitle = document.querySelector('.tee-option--size .tee-option__title');
  if(kiwiSizingChart && teeOptionTitle) { 
    var existingClone = teeOptionTitle.querySelector('.ks-chart-modal-link');
    if(!existingClone) {
      var kiwiSizingChartClone = kiwiSizingChart.cloneNode(true);
      teeOptionTitle.appendChild(kiwiSizingChartClone);
      kiwiSizingChartClone.addEventListener('click', function() { kiwiSizingChart.click() });
    }
  }
}
document.addEventListener("DOMContentLoaded", () => {
  const productTag = document.body?.dataset?.productTag || "";
    document.addEventListener('teeinblue-event-variant-changed', checkKiwiSizingChart);
    document.addEventListener('teeinblue-event-component-injected', () => {
      const checkElementRendered = setInterval(() => {
        if(document.querySelector('.ks-chart-container .ks-chart-modal-link')) {
          checkKiwiSizingChart();
          clearInterval(checkElementRendered);
        }
      },500)
      document.querySelectorAll('.tee-available-products .tee-radio').forEach((radio) => {
          radio.addEventListener('click', () => {
            setTimeout(() => { checkKiwiSizingChart() },200)     
          });
      });
    })
});


// document.addEventListener('teeinblue-event-component-injected', function () {
//   const formInputs = document.querySelector('#teeFormInputs');
//   const body = document.body;
//   if (body.dataset.productType === 'Ornament') {
//     if (formInputs) {
//       const img = document.createElement('img');
//       img.src = 'https://cdn.shopify.com/s/files/1/0604/6203/9094/files/duconspace-ornament-bulk-discount-banner_1.jpg?v=1762311143';
//       img.alt = 'Ornament bulk discount banner';
//       img.style.maxWidth = '384px';
//       img.style.width = '100%';
//       img.style.display = 'block';
//       img.style.marginBottom = '15px';
//       formInputs.parentNode.insertBefore(img, formInputs);
//     }
//   } else {
//     if (formInputs) {
//       const img = document.createElement('img');
//       img.src = 'https://cdn.shopify.com/s/files/1/0604/6203/9094/files/2025cutofff-Discount-Auto-Duconspace_1.webp?v=1764809395';
//       img.alt = '2025 cutOfff Discount';
//       img.style.maxWidth = '384px';
//       img.style.width = '100%';
//       img.style.display = 'block';
//       img.style.marginBottom = '15px';
//       formInputs.parentNode.insertBefore(img, formInputs);
//     }
//   }
// });


document.addEventListener('DOMContentLoaded', function () {

  document.addEventListener('click', function (e) {

    if (!e.target.closest) {
      return;
    }

    var badge = e.target.closest('.jdgm-preview-badge');

    if (!badge) return;

    e.preventDefault();
    e.stopPropagation();

    var reviewsTab = document.querySelector('.m-tab-header[data-block-type="reviews"]');

    if (!reviewsTab) return;

    reviewsTab.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });

    setTimeout(function () {
      reviewsTab.click();
    }, 500);
  }, true); // capture = true
});
